const MainPageContainer = ({ children }: { children: any }) => {
  return (
    <div
      id="MainPageContainer"
      className="flex flex-col gap-2 m-3 justify-between"
    >
      {children}
    </div>
  );
};

export default MainPageContainer;
